export default function HomeFAQ() {
  const faqs = [
    {
      q: "99视频需要付费吗？",
      a: "99视频是一个完全免费的在线视频聚合平台，您无需支付任何费用即可观看所有聚合的视频内容。我们聚合了香蕉视频、红桃视频、91视频、蜜桃视频等多个平台的优质内容，为观众提供一站式的免费观影体验。",
    },
    {
      q: "99视频支持哪些画质？",
      a: "99视频支持的画质包括标清、高清1080P和超高清4K等多种选择，具体取决于内容来源平台提供的画质选项。大部分最新电影和电视剧都支持4K超高清播放，确保您获得最佳的视觉体验。",
    },
    {
      q: "为什么在某些设备上播放会卡顿？",
      a: "播放卡顿通常与您的网络环境有关。99视频采用了智能自适应码率技术，会根据您的网络状况自动调整画质以确保流畅播放。如果遇到卡顿，建议尝试切换到较低的画质，或检查您的网络连接。",
    },
    {
      q: "99视频的内容多久更新一次？",
      a: "99视频的内容每日更新，我们会在各大合作平台上线新内容后第一时间进行聚合收录。最新电影、热播电视剧、综艺节目的更新速度通常在24小时内完成。热门榜单也会根据实际观看数据每日更新。",
    },
    {
      q: "99视频支持哪些设备观看？",
      a: "99视频全面支持PC端、平板电脑和手机端观看，兼容主流浏览器（Chrome、Safari、Edge、Firefox等）。无论您是在家中使用电脑，还是在外出时使用手机，都可以流畅地观看99视频的内容。",
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" aria-label="常见问题">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于99视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group rounded-lg bg-background-50 border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors">
                {faq.q}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a,
              },
            })),
          })}
        </script>
      </div>
    </section>
  );
}